import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { formatDuration, statusLabel } from '@/util/trackerPacing';


export default /*#__PURE__*/_defineComponent({
  __name: 'PacingStrip',
  props: {
  status: { type: String, default: '' },
  projectedFinish: { type: Number, default: null },
  projectedDelta: { type: Number, default: null },
  sampleSize: { type: Number, default: 0 },
  enoughHistory: { type: Boolean, default: false },
  timerPaused: { type: Boolean, default: false },
  minSample: { type: Number, default: 5 },
},
  setup(__props) {

const props = __props



const label = computed(() => statusLabel(props.status));

const projectionText = computed(() => {
  if (props.status === 'finished' || props.projectedFinish === null || props.projectedFinish === undefined) {
    return '';
  }
  let text = 'Projected finish ' + formatDuration(props.projectedFinish);
  if (props.projectedDelta !== null && props.projectedDelta !== undefined && props.projectedDelta > 0) {
    text += ', ' + formatDuration(props.projectedDelta) + ' over';
  }
  return text;
});

const popoverText = computed(() =>
  'Pacing compares this team with the last ' + props.sampleSize +
  ' finished events. Times count from the event start time on the Group step.'
);

return { __sfc: true,props, label, projectionText, popoverText }
}

})